import { ModuleWithProviders, NgModule } from '@angular/core';
import { IRecaptchaConfig, RECAPTCHA_CONFIG } from './recaptcha-config';

@NgModule()
export class RecaptchaModule {
  static forRoot(
    config: IRecaptchaConfig
  ): ModuleWithProviders<RecaptchaModule> {
    return {
      ngModule: RecaptchaModule,
      providers: [
        {
          provide: RECAPTCHA_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
